"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRedux = require("react-redux");

var _components = require("components");

var _DescriptionWith3Columns = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns");

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _Hero = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _Home = require("../Home/Home");

var _QouteSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/QouteSection");

var _QouteSection2 = _interopRequireDefault(_QouteSection);

var _Feature = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Feature");

var _Feature2 = _interopRequireDefault(_Feature);

var _ImageWithOverlayText = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/ImageWithOverlayText");

var _ImageWithOverlayText2 = _interopRequireDefault(_ImageWithOverlayText);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _VideoLinkSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/VideoLinkSection");

var _VideoLinkSection2 = _interopRequireDefault(_VideoLinkSection);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _utils = require("utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonsGroup = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(3)
});

var button = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(1),
  width: (0, _css.unitRem)(9.5),

  ":first-child": {
    marginLeft: 0
  }
});

var Megascans = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn
  };
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Megascans, _React$Component);

  function Megascans(props) {
    (0, _classCallCheck3.default)(this, Megascans);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Megascans.__proto__ || (0, _getPrototypeOf2.default)(Megascans)).call(this, props));

    _this.state = {
      platform: "Windows"
    };
    return _this;
  }

  (0, _createClass3.default)(Megascans, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: "render",
    value: function render() {
      var loggedIn = this.props.loggedIn;
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Megascans - The world's largest scanned 3D asset library",
          documentImage: cf_utils.cf_thumbs("page-thumb-megascans.jpg"),
          documentDescription: "Megascans is the world's largest 3D asset scans library full of high-resolution, PBR-calibrated surfaces, vegetation and modular scanned assets."
        },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_Hero2.default, {
            Indie: true,
            opacity: 0.25,
            bg: cf_utils.cf_qx_page("megascans", "megascans-productpage-hero.jpg"),
            superIconUrls: [cf_utils.cf_icons("megascans_icon_2048_preview.png")],
            primaryLabel: "",
            primaryTo: "",
            title: "Massive scan library",
            subTitle: "THE WORLD\u2019S LARGEST AND FASTEST GROWING SCAN LIBRARY",
            secondaryLabel: this.props.loggedIn ? "MY SCANS" : "Browse Megascans",
            secondaryTo: this.props.loggedIn ? "/megascans/purchased" : "/megascans/library/"
            // onClickSecondaryHandler={
            //   ()=>{ if(loggedIn) __CLIENT__ ? window.location=window.location.protocol+'//'+window.location.hostname+'/megascans/library/':'';}
            // }
            // secondaryLabel={this.props.loggedIn ? 'My Scans' : 'EXPLORE MEGASCANS'}
            // secondaryTo={this.props.loggedIn ? '/megascans/library/myscans' : { pathname: '/signup', query: { returnTo: '/megascans/library/free' }, state: { modal: true, navigateTo: '/megascans/library/free' }}}
            // toolTip={this.props.loggedIn ? null : toolTip}
            // linkIcon={'search'}
            , linkIcon: "rightSide",
            link: {
              label: this.props.loggedIn ? "Explore Megascans" : "Choose a plan",
              to: this.props.loggedIn ? "/megascans/library/" : "/pricing"
              // onClick:()=>( __CLIENT__ ? window.location=window.location.protocol+'//'+window.location.hostname+'/megascans/library/':'')
            },
            artist: "Ninja Theory"
          }),
          _react2.default.createElement(_DescriptionWith3Columns2.default, {
            title: "WHAT IS MEGASCANS",
            headingBeforeBreak: "#1 choice for",
            headingAfterBreak: "Games, VFX, ArchViz and beyond",
            columns: [{
              img: cf_utils.cf_icons("world_class_capture.svg"),
              isIcon: false,
              title: "World-class capture",
              desc: "Thousands of 3D and 2D assets are being scanned based on your immediate needs, so you focus on being creative."
            }, {
              img: cf_utils.cf_icons("instant_quality.svg"),
              isIcon: false,
              title: "Premium quality",
              desc: "Thanks to its incredible quality and depth, Megascans makes work fun & easy for the world’s top AAA and VFX studios."
            }, {
              img: cf_utils.cf_icons("industry_standard.svg"),
              isIcon: false,
              title: "Totally standardized",
              desc: "Optimized topology, UVs and LODs, consistent scale, resolution, and real-world PBR: the boring stuff is done for you."
            }]
          }),
          _react2.default.createElement(_VideoLinkSection2.default, {
            typeLable: "MEET MEGASCANS",
            YTid: "xz7W96vGgcA",
            bg: cf_utils.cf_qx_page("megascans", "vid-megascans.jpg")
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "MEGASCANS 2020",
            img: cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-1.jpg"),
            images: [cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-1.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-2.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-3.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-4.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-5.jpg")],
            title: "Discover every scan imaginable",
            newHome: true,
            desc: "Thousands of 3D assets, tileable surfaces, vegetation, imperfections, atlases, decals and much more, from urban to natural, with hundreds of new assets scanned weekly. Get a head start with everything you need from day 1, and use your creativity where it matters most.",
            link: [{
              to: "/megascans/home",
              label: "EXPERIENCE MEGASCANS"
              // onClick:()=>(__CLIENT__ ? window.location=window.location.protocol+'//'+window.location.hostname+'/megascans/library/':'')
            }]
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "MEGASCANS 2020",
            img: cf_utils.cf_qx_page("megascans", "megascans-oscar-winning-quality.jpg"),
            title: "Get Oscar-winning quality",
            newHome: true,
            desc: "Megascans allows for uncompromised quality and efficiency. It helps studios create beautiful scenery faster, such as MPC\u2019s Oscar-winning Megascans environments. Now that you have a world-class workflow at your disposal, what will you create?",
            flip: true
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "MEGASCANS 2020",
            img: cf_utils.cf_qx_page("megascans", "megascans-no-more-guesswork.jpg"),
            title: "Skip guesswork",
            newHome: true,
            desc: "Megascans is the definitive standardized content resource. All assets are consistently scanned, scaled and PBR calibrated, and every single 3D mesh comes with meticulously optimized topology, UVs and LODs, meaning less time doing boring work, and more time having fun.",
            link: [{
              // to: "/megascans/collections",
              label: "EXPLORE CURATED CONTENT",
              onClick: function onClick() {
                return __CLIENT__ ? window.location = window.location.protocol + "//" + window.location.hostname + "/megascans/collections" : "";
              }
            }]
          }),
          _react2.default.createElement(
            _Slider2.default,
            { delay: 7 },
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("4a-games-background.jpg"),
              icon: cf_utils.cf_testimonials("icon/4a-games.png"),
              title: "\u201CCreating an open world with the fidelity of a handcrafted experience requires a staggering amount of high quality assets. It was an incredibly difficult journey for us on Metro Exodus, and Megascans provided significant aid with their bottomless library of high-quality content.\u201D",
              subTitle: "\u2014 Sergei Karmalsky, Art Director, 4A Games",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("dice-test.jpg"),
              icon: cf_utils.cf_testimonials("icon/dice.png"),
              title: "\u201CMegascans is the one and only proper library for high quality scans on the market. Megascans was used throughout Battlefield V to bring in extra quality, flesh out environments, and lift the visual fidelity overall.\u201D",
              subTitle: "\u2014 Pontus Ryman, Senior Environment Artist, EA DICE",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("shadow-of-tomb-raider.jpg"),
              icon: cf_utils.cf_testimonials("icon/cdem.png"),
              title: "\u201CEidos-Montr\xE9al and Crystal Dynamics are proud to have used Quixel Megascans for Shadow of the Tomb Raider in order to help bring to life our meticulously crafted world.\u201D",
              subTitle: "\u2014 Eidos-Montr\xE9al & Crystal Dynamics",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("jungle-book.jpg"),
              icon: cf_utils.cf_testimonials("icon/technicolor.png"),
              title: "\u201CMegascans has become an indispensable resource when building photorealistic environments.\u201D",
              subTitle: "\u2014 Damien Fagnou, SVP, Technicolor",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("the-boundary.jpg"),
              icon: cf_utils.cf_testimonials("icon/boundary.png"),
              title: "\u201CMegascans has long been our go-to resource for all environment needs and has now become an invaluable tool across all types of projects at The Boundary.\u201D",
              subTitle: "\u2014 Henry Goss RIBA / Director, The Boundary",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("monster-hunter-world.jpg"),
              icon: cf_utils.cf_testimonials("icon/capcom.png"),
              title: "\u201CMegascans is a culmination of the very best assets to help simplify game development and aid in creating the highest quality games possible.\u201D",
              subTitle: "\u2014 Ryota Kanematsu, Environment Artist, Capcom",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("ronen-house.jpg"),
              icon: cf_utils.cf_testimonials("icon/craft.png"),
              title: "\u201CWhen it comes to achieving photorealism without compromising performance, Megascans hits all fronts\u2014with a PBR approach, drag-n-drop workflow, and ever-growing library.\u201D",
              subTitle: "\u2014 Ronen Bekerman, Co-Founder, The Craft",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("destiny-2.jpg"),
              icon: cf_utils.cf_testimonials("icon/bungie.png"),
              title: "\u201CMegascans provides the highest quality source material with intuitive tools to combine, permute and create unique new content.\u201D",
              subTitle: "\u2014 Tom Burlington, Technical Art Director, Bungie",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("book-of-the-dead.jpg"),
              icon: cf_utils.cf_testimonials("icon/unity.png"),
              title: "\u201CMegascans empowers even small teams like ours to achieve the quality and realism traditionally exclusive to large AAA productions.\u201D",
              subTitle: "\u2014 Veselin Efremov, Creative Director, Unity Demo Team",
              hr: true
            })
          ),
          _react2.default.createElement(_Feature2.default, {
            featureType: "MEGASCANS 2020",
            img: cf_utils.cf_qx_page("megascans", "megascans---go-beyond-photorealism.jpg"),
            title: "Go beyond photorealism",
            newHome: true,
            flip: true,
            desc: "At Quixel, we research, invent, and engineer all scanning hardware and processing software behind Megascans, to enable a level of photorealism you won\u2019t find anywhere else. Instantly get rid of the plastic look, and push yourself far beyond just photorealism.",
            link: [{
              // to: "/megascans/free",
              label: "TRY THE FREE SCANS",
              onClick: function onClick() {
                return __CLIENT__ ? window.location = window.location.protocol + "//" + window.location.hostname + "/megascans/home" : "";
              }
            }],
            artist: "Josef Bsharah"
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "MEGASCANS 2020",
            img: cf_utils.cf_qx_page("megascans", "megascans-with-passion-for-your-industry.jpg"),
            images: [cf_utils.cf_qx_page("megascans", "megascans-with-passion-for-your-industry-1.jpg"), cf_utils.cf_qx_page("megascans", "megascans-with-passion-for-your-industry-2.jpg"), cf_utils.cf_qx_page("megascans", "megascans-with-passion-for-your-industry-3.jpg"), cf_utils.cf_qx_page("megascans", "megascans-with-passion-for-your-industry-4.jpg"), cf_utils.cf_qx_page("megascans", "megascans-with-passion-for-your-industry-5.jpg")],
            title: "With passion for your industry",
            newHome: true,
            desc: "Prepared for Games, VFX, ArchViz, Ads and Automotive \u2014 even mobile, VR and AR \u2014 Megascans plugs right into your favorite tools and pipelines. Most games, films and digital experiences today leverage Megascans to look their best.",
            link: [{
              to: "/gallery",
              label: "VIEW THE GALLERY"
            }],
            artist: "Bartosz Domiczek",
            artists: ["Illusive Images", "Eidos-Montréal | Crystal Dynamics | Square Enix", "MPC Film | Disney", "Burrows", "SeithCG"]
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "MEGASCANS 2020",
            img: cf_utils.cf_qx_page("megascans", "megascans-uncompromizing-attention-to-detail.jpg"),
            title: "Uncompromising attention to detail",
            newHome: true,
            flip: true,
            desc: "On our global scanning expeditions, we scan entire biomes and ecoregions to capture everything contained within them. From the smallest blade of grass to the largest cliff, every element is scanned and made fully modular, enabling you to create the most detailed worlds imaginable.",
            link: [{
              to: "https://youtu.be/dtEl7WIzKHA",
              label: "BEHIND-THE-SCENES FOOTAGE",
              newWindow: true
            }]
          })
        )
      );
    }
  }]);
  return Megascans;
}(_react2.default.Component)) || _class);
exports.default = Megascans;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Apps/Megascans.jsx
// module id = 2938
// module chunks = 0